import $ from "jquery";
import { addressFormatter } from "../framework/addressFormatter";
import { countryState } from "./countryState";

function init() {
    countryState
        .populateCountriesSelect("#ddlEditPersonCountry", "#divEditNaState")
        .done(function() {
            setSelectedCountry($("#txtSelectedCountry").val());
            countrySelectionChanged();
            countryState.populateStatesSelect(
                "#divEditNaState",
                "#txtNonNaState",
                $("#txtSelectedCountry").val()
            );
            $("#selectPersonState").val($("#txtSelectedStateId").val());
        });
    setEvents();
}

function setEvents() {
    $("#ddlEditPersonCountry").change(countrySelectionChanged);
}

function countrySelectionChanged() {
    // Clear the value of the state name, otherwise the value is retained when jumping from country with state to country without state.
    $("#ShippingAddress_StateProvinceName").val("");
    
    const selectedCountry = $("#ddlEditPersonCountry").val();
    countryState.populateStatesSelect("#shipping-address-state", "#txtNonNaState", selectedCountry);
    countryState.populateStatesSelect("#billing-address-state", "#txtNonNaState", selectedCountry);
    addressFormatter.maskPhone($("#txtEditPhoneNumber"), selectedCountry);
    addressFormatter.maskZip($("#txtEditPostalCode, #Order_BillingAddress_PostalCode"), selectedCountry);
    addressFormatter.showIfUsOrCa("#NaPostalReq, #NaStateReq", selectedCountry);
}

function setSelectedCountry(selectedCountry) {
    $("#ddlEditPersonCountry").val(selectedCountry);
}

export const ordersShippingAddress = {
    init: init
};
